import clsx from 'clsx';

import { StudioBaseIconV2 } from 'shared/studio/StudioBaseIcon/StudioBaseIcon';
import { StudioBaseImageV2 } from 'shared/studio/StudioBaseImage/StudioBaseImage';

import { SUBSCRIPTION_PAGE_TYPE } from 'schema/subscription/pageType';
import { Spinner, Typography, Button, CloseIcon } from '@ag1/ui';
import styles from './PromotionalBannerV2.module.scss';
import { PromotionalBannerV2Props } from './PromotionalBannerV2.types';
import { useShowPromotionQty2V2 } from '../../hooks/useShowPromotionQty2V2';

const { SUBSCRIPTION_LIST } = SUBSCRIPTION_PAGE_TYPE;

export const PromotionalBannerV2 = ({
  page,
  bannerData,
  onClick,
  showSpinner
}: PromotionalBannerV2Props) => {
  const containerClassName = clsx(styles.container, {
    [styles.subDetailsPage]: page === SUBSCRIPTION_LIST
  });

  const { isOpen, handleClose } = useShowPromotionQty2V2();

  if (!isOpen || !bannerData) {
    return null;
  }

  return (
    <div className={containerClassName}>
      <div className={styles.mobileImageWrap}>
        <StudioBaseImageV2 image={bannerData.mobileImage} className={styles.mobileImage} />
      </div>
      <div className={styles.content}>
        {bannerData?.icon && (
          <div className={styles.icon}>
            <StudioBaseIconV2 icon={bannerData?.icon} />
          </div>
        )}
        <div className={styles.text}>
          <div className={styles.promotionLabel}>{bannerData.headlineCardText}</div>
          <Typography variant="portalSubtitle" size="2" weight="700" noPadding>
            {bannerData.headline}
          </Typography>
          <Typography variant="portalText" size="1" noPadding>
            <div
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: `${bannerData.subHeadline}<sup class="${styles.sup}">†</sup>`
              }}
            />
          </Typography>
          <Typography
            variant="portalText"
            size="2"
            fontStyle="italic"
            color="grey-1-new"
            className={styles.disclaimer}
            noPadding>
            <div
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: `<sup class="${styles.sup}">†</sup>${bannerData.disclaimerText}`
              }}
            />
          </Typography>
        </div>
      </div>
      <div className={styles.imageWrap}>
        <StudioBaseImageV2 image={bannerData.image} className={styles.image} />
      </div>
      <Button
        size="small"
        rounded
        theme="new"
        className={styles.button}
        disabled={showSpinner}
        onClick={onClick}>
        {showSpinner ? (
          <Spinner color="brand-green" size={24} withOverlay={false} />
        ) : (
          bannerData.ctaText
        )}
      </Button>
      <Typography
        variant="portalText"
        size="2"
        fontStyle="italic"
        color="grey-1-new"
        className={styles.disclaimerMobile}
        noPadding>
        <div
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: `<sup class="${styles.sup}">†</sup>${bannerData.disclaimerTextShort}`
          }}
        />
      </Typography>
      <button type="button" className={styles.btnClose} onClick={handleClose}>
        <CloseIcon size={24} className={styles.btnCloseIcon} />
      </button>
    </div>
  );
};
